import {colors} from 'shells/colors/colors';
import {AccountIcon} from 'shells/icon/svg/account-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ActivityIcon} from 'shells/icon/svg/activity-icon';
import {ContactIcon} from 'shells/icon/svg/contact-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ImportIcon} from 'shells/icon/svg/icon-import';
import {InvoiceIcon} from 'shells/icon/svg/invoice-icon';
import {LeadIcon} from 'shells/icon/svg/lead-icon';
import {QuoteIcon} from 'shells/icon/svg/quote-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TaskIcon} from 'shells/icon/svg/task-icon';
import {WebFormIcon} from 'shells/icon/svg/web-form-icon';

export function getAddNewCards(userCanAccessSalesDocuments: boolean): Array<{
    icon: any;
    iconColor: string;
    title: string;
    description: string;
    to: string;
    isModalLink: boolean;
}> {
    const cards = [
        {
            icon: AccountIcon,
            iconColor: colors.plum,
            title: 'Company',
            description: 'Organizations and groups you may do business with',
            to: 'accounts',
            isModalLink: true,
        },
        {
            icon: ContactIcon,
            iconColor: colors.navy,
            title: 'Person',
            description: 'Individuals you know or may do business with',
            to: 'contacts',
            isModalLink: true,
        },
        {
            icon: LeadIcon,
            iconColor: colors.greenDk,
            title: 'Lead',
            description: 'A deal or opportunity to make a sale',
            to: 'leads',
            isModalLink: true,
        },
        {
            icon: ActivityIcon,
            iconColor: colors.activity,
            title: 'Activity',
            description: 'Phone calls, meetings, and other interactions',
            to: 'activities',
            isModalLink: true,
        },
        {
            icon: TaskIcon,
            iconColor: colors.task,
            title: 'Task',
            description: 'Reminders and other things you don’t want to forget',
            to: 'tasks',
            isModalLink: true,
        },
        {
            icon: WebFormIcon,
            iconColor: colors.sidebarPrimary,
            title: 'Form',
            description: 'Collect leads directly from your website',
            to: 'forms',
            isModalLink: true,
        },
        {
            icon: ImportIcon,
            iconColor: colors.sidebarPrimary,
            title: 'Import',
            description: 'Transfer your existing data into Nutshell',
            to: '/setup/import',
            isModalLink: false,
        },
    ];

    if (userCanAccessSalesDocuments) {
        cards.push(
            {
                icon: QuoteIcon,
                iconColor: colors.lead,
                title: 'Quote',
                description: 'Create and send quotes directly from your leads',
                to: 'quotes',
                isModalLink: true,
            },
            {
                icon: InvoiceIcon,
                iconColor: colors.lead,
                title: 'Invoice',
                description: 'Create and send invoices directly from your leads',
                to: 'invoices',
                isModalLink: true,
            }
        );
    }

    return cards;
}
